import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';


@Directive({
    selector: '[appAgeInputAutoFill]'
})
export class AgeInputAutoFillDirective {
    constructor(private formControl: NgControl) {
    }

    @HostListener('blur')
    onBlur() {
        if (!!this.formControl &&
            this.formControl.invalid &&
            new RegExp(/^\d+$/).test(this.formControl.value)) {
            this.formControl.control.setValue(`${this.formControl.value}.0`);
        }
    }
}